import { makeAutoObservable } from 'mobx';
import { UserDataI } from '../types';
import Api from '../api/API';
import { decodeToken, downloadUserImage } from '../utils/functions';

class User {
  isProfileFetched = false;
  profile: UserDataI = {
    countryCode: 'Poland',
    id: 0,
    name: '',
    portraitUrl: '',
    positionName: '',
    whoIsOffView: 'NONE',
    globalSearchView: 'NONE',
    isAllUserRequiredDataPresent: true,
    isNewlistPopupViewed: false,
    ignoreCalendarValidations: false,
    hierarchyPath: '',
  };
  anotherUser: UserDataI = {
    id: 0,
    positionName: '',
    name: '',
    portraitUrl: '',
    countryCode: 'Poland',
    whoIsOffView: 'NONE',
    globalSearchView: 'NONE',
    isAllUserRequiredDataPresent: true,
    isNewlistPopupViewed: false,
    ignoreCalendarValidations: false,
    hierarchyPath: '',
  };
  isFetchedAnotherUser = false;
  avatar = '';

  roles: {
    fetched: boolean,
    values: string[]
  } = {
      fetched: false,
      values: []
    };

  constructor() {
    makeAutoObservable(this);
  }

  fetchUserProfile = async () => {
    const decodedToken = decodeToken();
    this.profile = await Api<null, UserDataI>().get(`${process.env.REACT_APP_LM_API_URL}/api/${process.env.REACT_APP_API_VERSION}/employees/profile-by-email?email=${decodedToken.email}`);
    this.isProfileFetched = true;
  };

  fetchAnotherUser = async (id: string) => {
    try {
      this.isFetchedAnotherUser = false;
      this.anotherUser = await Api<null, UserDataI>().get(`${process.env.REACT_APP_LM_API_URL}/api/${process.env.REACT_APP_API_VERSION}/employees/${id}/profile`);
      setTimeout(() => {
        this.isFetchedAnotherUser = true;
      }, 400);
    }
    catch (e) {
      this.isFetchedAnotherUser = false;
    }
  };

  fetchUserRoles = async () => {
    try {
      this.roles.values = await Api<null, string[]>().get(`${process.env.REACT_APP_LM_API_URL}/api/${process.env.REACT_APP_API_VERSION}/user-roles`);
      this.roles.fetched = true;
    }
    catch (e) {
      this.roles.values = [];
      this.roles.fetched = true;
    }
  };

  async fetchPortraitUrl() {
    const fetchedAvatar = await downloadUserImage(this.profile.portraitUrl);
    this.avatar = fetchedAvatar.blob;
  }

  async setNewListPopupVisibility(visibility: boolean) {
    this.profile.isNewlistPopupViewed = visibility;
    Api<null, null>().put(`${process.env.REACT_APP_LM_API_URL}/api/${process.env.REACT_APP_API_VERSION}/employees/newlist-popup-gotit-flag?isNewlistPopupViewed=${visibility}`, null);
  }
}

export const UserStore = new User();
